import React from 'react';
import { useEffect, useState } from 'react';
import { ClipControls } from '../ClipControls/ClipControls';
import { FormatDate } from '../../helpers/FormatDate';
import { getScreenshotSignedUrl, getClipListens } from '../../services/HalogenService';

export const FocusClip = ({ clip }) => {
    const [numListens, setNumListens] = useState(clip.numListens ? clip.numListens : 0);
    const [screenshotUrl, setScreenshotUrl] = useState(clip.imageURL);

    const getImageSize = () => {
        const width = window.innerWidth;
        if(width < 600) {
            return 'small';
        } else if(width >= 600 && width < 1000) {
            return 'medium';
        } else {
            return 'large';
        }
    };

    useEffect(() => {
        if (!clip.imageURL) {
            getScreenshotSignedUrl(clip.id, getImageSize())
                .then(url => setScreenshotUrl(url.signedUrl))
                .catch(err => console.error(err));
        }
        if (clip.numListens === undefined) {
            getClipListens(clip.id)
                .then(listens => setNumListens(listens.listens))
                .catch(err => console.error(err));
        }
    }, [clip.id, clip.imageURL, clip.numListens]);

    return (
        <div style={styles.focusClipContainer}>
            <div style={styles.contentContainer}>
                <div style={styles.focusTitleAndDate}>
                    <h1 style={styles.title}>{clip.title}</h1>
                    <p style={{ fontSize: '12px', fontFamily: 'Poppins', padding: '10px', paddingBottom: 0, margin: 0 }}>
                        {FormatDate(clip.created_at)} | {numListens} listens
                    </p>
                </div>
                <div style={styles.imageContainer}>
                    <img src={screenshotUrl} alt="Visual Content" style={styles.image} onClick={() => {
                        window.open(clip.link, '_blank', 'noopener,noreferrer');
                    }} />
                </div>
                <p style={styles.contextText}>{clip.context}</p>
                <p style={styles.descriptionText}>{clip.description}</p>
            </div>
            <div style={styles.clipControlsContainer}>
                <ClipControls clip={clip} color={'#F2EFF4'} />
            </div>
        </div>
    );
};

const styles = {
    focusClipContainer: {
        display: 'flex',
        backgroundColor: 'rgb(80, 80, 80, 0.3)',
        color: '#F2EFF4',
        borderRadius: '25px',
        padding: '20px',
        gap: '10px',
        width: '90%', // or '830px' if you want to keep a fixed width
        alignItems: 'center',
        flexDirection: 'column',
        fontFamily: 'Poppins',
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '100%',
    },
    title: {
        margin: 0,
        alignSelf: 'center',
        padding: '10px',
        paddingBottom: 0,
        fontSize: '24px',
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center', // This centers the image horizontally in the container
        width: '100%',
        margin: '7px 0',
    },
    image: {
        borderRadius: '10px',
        width: '75%', // Scales image width relative to its height to maintain aspect ratio
        height: 'auto', // Scales image height relative to its width to maintain aspect ratio
        objectFit: 'contain', // Ensures the image is scaled correctly to fit within its container
        cursor: 'pointer',
    },
    contextText: {
        color: '#B0B0B0',
        marginBottom: 0,
        // padding: '10px',
        paddingTop: 0,
        flexGrow: '0',
        fontStyle: 'italic',
        fontSize: '14px',
    },
    descriptionText: {
        margin: 0,
        // padding: '10px',
        fontSize: '16px',
        // letterSpacing: '1.5px',
    },
    clipControlsContainer: {
        display: 'flex',
        width: '100%',
        padding: 0,
        alignSelf: 'center',
        borderRadius: '0 0 15px 15px',
        padding: '10px 0',
        margin: 0,
    },
    titleAndImage: {
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
};

